<template>
    <div id="showcomps">
        <Reminder :remdata="remdata" :remshow="remshow" />
		<loading :active.sync="fullPageWait"
                 :can-cancel="false"
                 :is-full-page="true"/>
        <b-modal
            v-model="icoShow"
            title="Component"
            class="modal-alerts"
            :ok-only="true"
            ok-title="Close"
        >
            Component: {{ icoCodice }} rev. {{ icoRev }}<br />
            <img
                width="100%"
                height="100%"
                :src="`${SERVER}/icon?code=${cleanCode(icoCodice)}&rev=${icoRev}`"
            />
        </b-modal>
        <b-modal
            v-model="confirmRequest"
            size="lg"
            title="Confirm your request"
            class="modal-alerts"
            :ok-only="false"
            ok-title="Add to cart"
			@ok="sendRequest"
        >
            <div>Please check below the selected items and once you will be fine add them to the cart<br><br>
                <span v-if="m">Machine: {{m.codice}}</span>
            </div>
            <table>
                <tr>
                    <th>Code</th><th>Description</th><th>Qty</th><th>Urgent</th>
                </tr>
                <tr v-for="(o) of orderItems" :key="o.codice">
                    <td>{{o.codice}}</td>
                    <td>{{o.descrizione}}</td>
                    <td>{{o.reorder}}</td>
                    <td><input type="checkbox" v-model="urgent" :value="o"/></td>
                </tr>
            </table>
        </b-modal>
        <h1>Full search by part</h1>
        <b-button
                    v-if="!$store.getters.ro && isClient"
                    :class="!main ? 'sendrfq' : 'sendrfq sendrfq2'"
                    :variant="orderVariant"
                    :disabled="orderDisabled"
                    @click="request()"
                    ><v-icon name="cart-plus" /> Add to Cart
        </b-button>
        <b-button :class="!main ? 'xlsexport' : 'xlsexport xlsexport2'" @click="esporta()" >Export to Excel</b-button>
        <div :class="!main ? 'billspieghe' : 'billspieghe billspieghe2'">
            The following list is the <b>Bill of Material</b> of your equipment. It is always updated after all the Service interventions.<br>
            Number that appears in the brackets on the right of the code indicates how many times the code is present in the full Bill Of Material.<br>
            <b>R.</b>: The code is <b>RECOMMENDED</b>.<br>
            <b>S.R.</b>: The code is <b>STRONGLY RECOMMENDED</b><br>
            <b>A.O.</b>: The code has been <b>ALREADY ORDERED</b> in the past (even if not necessarily for the current machine).<br>
        </div>
        <b-alert v-model="mailSent" variant="info" dismissible>
            Your RFQ has been sent. You'll receive a copy for your reference
        </b-alert>
        <DxTreeList
            id="treecomponents"
            :data-source="dataSource"
            :show-borders="true"
            :column-auto-width="true"
            :word-wrap-enabled="true"
            :expanded-row-keys="expandedRowKeys"
            :selected-row-keys="selectedRowKeys"
            ref="treeview"
            key-expr="id_elemento"
            parent-id-expr="id_padre"
            :auto-expand-all="true"
        >
            <DxSearchPanel :visible="true" :width="250" />
            <DxHeaderFilter :visible="true" />
            <!-- <DxSelection mode="multiple" /> -->
            <DxColumnChooser :enabled="false" />

            <DxColumn :width="200" data-field="codice" caption="Code" />
            <DxColumn
                :width="100"
                data-field="codice"
                caption="Icon"
                cell-template="icoTemplate"
            />
            <DxColumn
                :width="75"
                caption="R."
                data-field="r"
                cell-template="radioTemplateR"
                header-cell-template="hradioTemplateR"
            />
            <DxColumn
                :width="75"
                caption="S.R."
                data-field="sr"
                cell-template="radioTemplateSR"
                header-cell-template="hradioTemplateSR"
            />
            <DxColumn
                :width="75"
                caption="A.O."
                data-field="ordered"
                cell-template="radioTemplateAO"
                header-cell-template="hradioTemplateAO"
            />
            <DxColumn :width="600" data-field="descrizione" caption="Description" />
            <DxColumn
                :width="100"
                caption="Reorder"
                data-field="reorder"
                cell-template="radioTemplateReorder"
            />
            <DxColumn
                :width="100"
                data-field="codice"
                caption="Reminder"
                cell-template="reminderTemplate"
            />
            <template #reminderTemplate="{ data: d }">
                <b-button
                    v-if="!$store.getters.ro"
                    class="pointer"
                    variant="info"
                    @click="remind(d.data)"
                >Set Reminder</b-button>
            </template>
            <template #icoTemplate="{ data: d }">
                <img
                    class="pointer"
                    width="64"
                    height="64"
                    :src="`${SERVER}/icon?code=${cleanCode(d.data.codice)}&rev=${d.data.revisione}`"
                    @click="show(d.data.codice, d.data.revisione)"
                />
            </template>
            <template #radioTemplateR="{ data: d }">
                <input
                    type="checkbox"
                    v-model="d.data.r"
                    onclick="return false;"
                />
            </template>
            <template #hradioTemplateR="{  }">
                <span title="Reccommended Items">R.</span>
            </template>
            <template #radioTemplateSR="{ data: d }">
                <span>
                    <input
                        type="checkbox"
                        v-model="d.data.sr"
                        onclick="return false;"
                    />
                </span>
            </template>
            <template #hradioTemplateSR="{  }">
                <span title="Stronlgy Reccommended Items">S.R.</span>
            </template>
            <template #radioTemplateAO="{ data: d }">
                <input
                    type="checkbox"
                    v-model="d.data.ordered"
                    onclick="return false;"
                />
            </template>
            <template #hradioTemplateAO="{  }">
                <span title="Already Ordered">A.O.</span>
            </template>
            <template #radioTemplateReorder="{ data: d }">
                <input
                    type="number"
                    min="0"
                    v-model="d.data.reorder"
                    @change ="checkNumOrdered"
                    class="w50"
                />
            </template>
        </DxTreeList>
    </div>
</template>
<script>
import {
    DxTreeList,
    DxColumn,
    DxColumnChooser,
    DxHeaderFilter,
    DxSearchPanel,
    // DxSelection,
} from "devextreme-vue/tree-list";
// import { treecomponents, employees, priorities } from './data.js';
import { API } from "@/api.js";
import Reminder from "@/components/Reminder.vue";
import Loading from 'vue-loading-overlay';

const development = process.env.NODE_ENV === "development";
const SERVER = development
    ? "http://localhost:81"
    : location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "");

const statuses = [
    "Not Started",
    "Need Assistance",
    "In Progress",
    "Deferred",
    "Completed",
];

export default {
    components: {
        DxTreeList,
        DxColumn,
        DxColumnChooser,
        DxHeaderFilter,
        DxSearchPanel,
        // DxSelection,
        Loading,
        Reminder,
    },
    props: {
        m: Object,
        main: Boolean,
        search: String,
    },
    data() {
        return {
            remshow: 0,
            remdata: {},
            mailSent: false,
            fullPageWait: false,
            expandedRowKeys: [1, 2],
            selectedRowKeys: [1, 29, 42],
            // employees,
            // priorities,
            statuses,
            components: [], // questo viene via via svuotato
            urgent: [],
            icoShow: false,
            icoCodice: "",
            icoRev: "",
            someOrdered: false,
            confirmRequest: false,
        };
    },
    watch: {
        logged(){
            this.showPrivacy = !this.privacyOK && this.logged && !this.prelogged
            console.log("logged",this.privacyOK,this.logged,this.prelogged)
        },
        search() {
            console.log("search", this.search);
            this.init();
        },
    },
    updated(){
        console.log("updated")
        try {
            let div = document.querySelector('div.dx-treelist-headers')
            div.style.position = "relative"
            div.style['z-index'] = 999
            div.style['background-color'] = 'white'
            let divs = document.querySelector('div.scrollami')
            if(divs) {
                divs.addEventListener("scroll", (event) => {
                    let y = divs.scrollTop
                    console.log("scroll",event,y)
                    if(y>167)
                        div.style.top = (y - 167) + "px"
                    else
                        div.style.top = "0px"
                });
            }
        } catch (error) {
            console.error("Support Mount", error);
        }
        this.checkNumOrdered()
    },
    mounted() {
        this.init();
    },
    computed: {
        orderVariant() {
            return this.someOrdered ? "info" : "";
        },
        orderDisabled() {
            return !this.someOrdered;
        },
        SERVER() {
            return SERVER;
        },
        dataSource() {
            return this.components;
        },
        orderItems(){
            return this.components.filter((c) => c.reorder && c.reorder>0)
        },
        isClient() {
            console.log("mm1 ?", this.$store.getters.master, this.$store.getters.marsilli)
            return !this.$store.getters.marsilli
        },
    },
    methods: {
        remind(data){
            console.log("REMIND:",data)
            this.remdata = data
            this.remshow++
        },
        cleanCode(c) { // elimina la aprte aggiuntiva che impedisce il caricamento dell'immagine
            return c ? c.split(" ")[0] : c
        },
        async esporta(){
            let tv = this.$refs["treeview"].instance
            var columns = tv.getVisibleColumns();  
            var data = tv.getVisibleRows();  
            var csvContent = "SEP=, \r\n";  

            for (let i = 0; i < columns.length; i++) {  
                if(i==1 || i>6) continue
                csvContent += columns[i].caption + ",";  
            }
            csvContent += "\r\n";  
            for (let i = 0; i < data.length; i++) {  
                console.log("data " + i,data[i])
                let row = data[i].values;
                let level = data[i].level
                // per ogni elemento metto anche tanti asterischi quanta è la profondità nella gerarchia
                row.forEach(function (item, index) {  
                    if(index==1 || index>6) return
                    let star = ""
                    if(index==0) {
                        // metto tanti asterischi quant'è il level
                        star = "*".repeat(level)
                    }
                    if (item === undefined || item === null) { csvContent += ","; }  
                    else { csvContent += star + " " + item + ","; }
                   }  
                );  
                csvContent += "\r\n";  
            }  
            var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });  

            if (navigator.msSaveBlob) {  
                navigator.msSaveBlob(blob, 'Job_Progress.csv')  
            }  
            else {  
                var link = document.createElement("a");  
                var url = URL.createObjectURL(blob);  
                link.setAttribute("href", url);  
                link.setAttribute("download", "Job_Progress.csv");  
                document.body.appendChild(link);  
                link.click();  
                document.body.removeChild(link);  
            }
        },
		async sendRequest(){
            console.log("invio richiesta...")
            let reqId = await API.createRequest()
            for(let oi of this.orderItems) {
                let codice = oi.codice.split(" ")[0] // rimuovo la quantità fra parentesi
                let urgente = this.urgent.map(u => u.codice).includes(oi.codice)
                await API.addRequestItem(reqId,codice,oi.descrizione,urgente,oi.reorder)
            }
        },
        checkNumOrdered() {
			let numord = this.components.filter((c) => c.reorder>0).length;
            this.someOrdered = numord>0
            console.log("numord", numord,this.components.filter((c) => c.reorder));
        },
        request() {
			this.confirmRequest = true
		},
        show(c, r) {
            this.icoCodice = c;
            this.icoRev = r;
            this.icoShow = true;
        },
        async init() {
            if(!this.m && !this.search) return
            this.fullPageWait = true
            // console.log("M", this.m);
            let codice = this.m ? this.m.codice : null
            let res = await API.getTree(codice, this.search);
            let ordered = await API.getSpares(codice, this.search);
            // console.log("components", this.components);
            this.components = res.data;
            // ho cercato tutti quelli già ordinati e setto il flag
            // let setted = 0;
            for (let o of ordered) {
                for (let c of this.components) {
                    if (c.codice == o.spare_code) {
                        c.ordered = true;
                        // setted++;
                    }
                }
            }
            // console.log("ordered", setted, ordered);
            if(this.m) {
                // inserisco il primo che è la radice
                let root = this.components.find((c) => c.first == 1);
                if(root) {
                    let padre = {
                        id_elemento: root.id_padre,
                        codice: this.m.codice,
                        descrizione: this.m.nome,
                        id_padre: 0,
                        r: false,
                        sr: false,
                        ordered: false,
                        reorder: 0,
                    };
                    for(let c of this.components) {
                        c.reorder = 0
                        c.codice = c.codice + ` (${c.qta})`
                    }
                    this.components.unshift(padre);
                }
            } else {
                this.expandedRowKeys = this.components.map((c) => c.id_elemento);
            }
            this.fullPageWait = false
        },
        customizeTaskCompletionText(cellInfo) {
            return `${cellInfo.valueText}%`;
        },
    },
};
</script>
<style>
#showcomps button.btn-info {
	background-color: #6b1106;
	border-color: #6b1106;
}
#showcomps img.pointer {
    cursor: pointer;
}
#treecomponents {
    max-height: 100%;
    height: 100%;
}

#treecomponents .dx-treelist-rowsview td {
    vertical-align: middle;
}
#treecomponents div.dx-treelist-headers {
    margin-top: 90px;
}
</style>
<style scoped>
.xlsexport {
    position: absolute;
    top: 85px;
    left: 800px;
    width: 200px;
    z-index: 99;
}
.xlsexport2 {
    /* top: 260px; */
    top: 105px;
}
.sendrfq {
    position: absolute;
    top: 85px;
    left: 1045px;
    width: 200px;
    z-index: 99;
}
.sendrfq g {
    fill: white;
}
.sendrfq2 {
    /* top: 260px; */
    top: 105px;
}
div.billspieghe {
    position: absolute;
    left: 20px;
    z-index: 99;
    width: 750px;
    text-align: left;
    top: 70px;
    font-size: x-small;
}
div.billspieghe2 {
    /* top: 255px; */
    top: 110px;
}
h1 {
    position: absolute;
    left: 20px;
    z-index: 99;
}
h1 span.r {
    float: right;
    fill: white;
    margin-left: 100px;
    position: relative;
    bottom: 6px;
}
td {
	padding: 5px;
}
input.w50 {
    width: 50px;
}
</style>
